/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon16Light = forwardRef('MediaAudioVolumeSMinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2.057a.75.75 0 0 0-1.248-.56L3.81 5H1.25C.56 5 0 5.56 0 6.25v3.5C0 10.44.56 11 1.25 11h2.56l3.942 3.504A.75.75 0 0 0 9 13.944V2.056Zm-4.526 3.69L8 2.613v10.774l-3.526-3.134A1 1 0 0 0 3.81 10H1.25A.25.25 0 0 1 1 9.75v-3.5A.25.25 0 0 1 1.25 6h2.56a1 1 0 0 0 .664-.253Z" }),
        React.createElement("path", { d: "M11.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" })));
});
